<template>
  <div>
    <page-header :title="$t('dictionary.command_log')" />
    <page-body>
      <command-log-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import CommandLogList from './components/List'

export default {
  name: 'CommandLog',
  components: {
    CommandLogList,
  },
  data () {
    return {
      listId: 'CommandLogList',
    }
  },
}
</script>
